import { useState } from 'react';

import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import InputFileUpload from 'shared/components/Input/InputUploadFile/InputFileUpload';
import TableRender, { TableRenderFieldT } from 'shared/components/Table/TableRender';
import { APIErrorT } from 'shared/models/api';
import SCHCTemplate from 'shared/models/SCHCTemplate';
import api from 'utils/api';
import { datePrettyDisplay, formatDateFromNow } from 'utils/date';
import { hasPermissionOnSCHCTemplate, useAuth } from 'utils/hooks/providers/auth-context';

import './SCHCTemplates.scss';

function SCHCTemplates() {
  const [rerenderTable, setRerenderTable] = useState(0);
  const history = useHistory();
  const { authState } = useAuth();

  const uploadFile = (dataToUpload: any) => {
    api.SCHCTemplates.registerFromJSONFile(dataToUpload)
      .then((resp: any) => {
        if (resp.status >= 400) {
          resp.json()
            .then((error: APIErrorT) => {
              toast.error(`Failed to upload the file - ${error?.message}`);
            });
        } else {
          resp.json()
            .then(() => {
              setRerenderTable((count) => count + 1);
            });
        }
      });
  };

  const goToID = (id: string) => {
    history.push(`/schc-templates/${id}`);
  };

  const fields: TableRenderFieldT[] = [
    {
      displayName: 'Name',
      renderFn: (row: SCHCTemplate.API.BodyT) => row.name,
    },
    {
      displayName: 'SCHC Template ID',
      renderFn: (row: SCHCTemplate.API.BodyT) => row.sCHCTemplateID,
      align: 'center',
    },
    {
      displayName: 'Nb Device Profiles',
      renderFn: (row: SCHCTemplate.API.BodyT) => row.nbDeviceProfiles,
      align: 'center',
    },
    {
      displayName: 'Nb Rules',
      renderFn: (row: SCHCTemplate.API.BodyT) => `${row.deviceSchcRules.length}`,
      align: 'center',
    },
    {
      displayName: 'Organization',
      renderFn: (row: SCHCTemplate.API.BodyT) => row.organization,
      align: 'center',
    },
    {
      displayName: 'Created by',
      renderFn: (row: SCHCTemplate.API.BodyT) => row.createdBy,
      align: 'center',
    },
    {
      displayName: 'Last Update',
      renderFn: (row: SCHCTemplate.API.BodyT) => formatDateFromNow(row.lastUpdated),
      tooltipFn: (row: SCHCTemplate.API.BodyT) => datePrettyDisplay(row.lastUpdated),
      align: 'center',
    },
  ];

  return (
    <div>
      <div className="title__header">
        <h1>SCHC Templates</h1>
        <div className="title__header--actions">
          {
            hasPermissionOnSCHCTemplate(authState) ? (
              <>
                <InputFileUpload
                  title="Upload templates"
                  variant="outlined"
                  color="info"
                  onFileLoaded={uploadFile}
                  acceptedFiles=".json"
                />
                <Link to="/schc-templates/create">
                  <Button variant="contained" color="secondary">Create</Button>
                </Link>
              </>
            ) : null
          }
        </div>
      </div>
      <TableRender
        api={api.SCHCTemplates}
        renderFields={fields}
        onClickRow={(row: SCHCTemplate.API.BodyT) => goToID(row.iD)}
        forceRerender={rerenderTable}
      />
    </div>
  );
}

export default SCHCTemplates;
